var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import EdsErrorPage from '@ellucian/react-design-system/core/es/ErrorPage';
import Tokens from '../../core/styles/Tokens';
import { createStyles, withStyles } from '../../core/styles/withStyles';
import Format from '../../../helpers/Format';
const styles = createStyles({
    errorPageContainer: {
        height: `calc(100vh - ${Format.toSumRem([Tokens.spacing85, Tokens.spacing85])})`
    }
});
const ErrorPage = (props) => {
    const { classes } = props, rest = __rest(props, ["classes"]);
    return (React.createElement("div", { className: classes.errorPageContainer },
        React.createElement(EdsErrorPage, Object.assign({}, rest))));
};
export default withStyles(styles)(ErrorPage);
